export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type AdditionalDeliveryField = {
  __typename?: 'AdditionalDeliveryField';
  name: Maybe<Scalars['String']['output']>;
};

export type CoverSetup = {
  __typename?: 'CoverSetup';
  coverSetupId: Maybe<Scalars['ID']['output']>;
  file: Maybe<Scalars['String']['output']>;
  size: Maybe<CoverSize>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type CoverSize = {
  __typename?: 'CoverSize';
  h: Maybe<Scalars['Int']['output']>;
  w: Maybe<Scalars['Int']['output']>;
};

export type CoverSizeInput = {
  h: Scalars['Int']['input'];
  w: Scalars['Int']['input'];
};

export type CoverUpdateDetails = {
  file: Scalars['String']['input'];
  size: CoverSizeInput;
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CustomLabel = {
  __typename?: 'CustomLabel';
  language: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type CustomLabelInput = {
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type DecorationField = {
  __typename?: 'DecorationField';
  decorationFieldId: Maybe<Scalars['ID']['output']>;
  types: Maybe<Array<Maybe<DecorationFieldType>>>;
};

export enum DecorationFieldType {
  Connector = 'Connector',
  Date = 'Date',
  FirstName = 'FirstName',
  FirstNameInitial = 'FirstNameInitial',
  SecondName = 'SecondName',
  SecondNameInitial = 'SecondNameInitial',
}

export type DecorationForClient = {
  __typename?: 'DecorationForClient';
  decorationForClientId: Maybe<Scalars['ID']['output']>;
  fields: Maybe<Array<Maybe<DecorationField>>>;
};

export type DecorationPreConfigForClient = {
  __typename?: 'DecorationPreConfigForClient';
  connector: Maybe<Scalars['String']['output']>;
  date: Maybe<Scalars['String']['output']>;
  decorationPreConfigForClientId: Maybe<Scalars['ID']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  secondName: Maybe<Scalars['String']['output']>;
};

export type DeliveryMethod = {
  __typename?: 'DeliveryMethod';
  additionalFields: Maybe<Array<Maybe<AdditionalDeliveryField>>>;
  addressRequired: Maybe<Scalars['Boolean']['output']>;
  context: Maybe<Array<Maybe<DeliveryMethodContext>>>;
  countryId: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['String']['output']>;
  deliveryMethodId: Maybe<Scalars['ID']['output']>;
  easyPackOrgId: Maybe<Scalars['ID']['output']>;
  easyPackToken: Maybe<Scalars['ID']['output']>;
  freeFrom: Maybe<Scalars['Float']['output']>;
  label: Maybe<Scalars['String']['output']>;
  mightBeFree: Maybe<Scalars['Boolean']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  phoneRequired: Maybe<Scalars['Boolean']['output']>;
  pickupAddress: Maybe<Scalars['String']['output']>;
  pickupNote: Maybe<Scalars['String']['output']>;
  preOrderNote: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<DeliveryType>;
};

export enum DeliveryMethodContext {
  EmbedStore = 'EmbedStore',
  Lab = 'Lab',
  PrivateSession = 'PrivateSession',
  PublicSession = 'PublicSession',
  Wedding = 'Wedding',
}

export enum DeliveryType {
  Courier = 'Courier',
  Digital = 'Digital',
  EasyPack24 = 'EasyPack24',
  Pickup = 'Pickup',
}

export type FilePricing = {
  __typename?: 'FilePricing';
  filePricingId: Maybe<Scalars['String']['output']>;
  isFull: Maybe<Scalars['Boolean']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printsIncluded: Maybe<Array<Maybe<PrintsCount>>>;
  size: Maybe<Scalars['Int']['output']>;
  stepPricing: Maybe<StepPricing>;
  stepPricingEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type FilePricingInput = {
  filePricingId: Scalars['String']['input'];
  isFull: Scalars['Boolean']['input'];
  price: Array<InputMaybe<PriceConfigInput>>;
  printsIncluded: Array<InputMaybe<UpdatePrintsCount>>;
  size: Scalars['Int']['input'];
  stepPricing: StepPricingInput;
  stepPricingEnabled: Scalars['Boolean']['input'];
};

export enum FilesAndPrintsPackageType {
  AnyImage = 'AnyImage',
  OneImage = 'OneImage',
  PickedImage = 'PickedImage',
}

export type FilesConfig = {
  __typename?: 'FilesConfig';
  count: Maybe<Scalars['Int']['output']>;
  isFull: Maybe<Scalars['Boolean']['output']>;
  size: Maybe<Scalars['Int']['output']>;
};

export type ForcedImageConfig = {
  __typename?: 'ForcedImageConfig';
  photoGroupId: Maybe<Scalars['ID']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
};

export type ImageForDisplay = {
  __typename?: 'ImageForDisplay';
  height: Maybe<Scalars['Int']['output']>;
  originalName: Maybe<Scalars['String']['output']>;
  photoGroupHasPhotoId: Scalars['String']['output'];
  photoGroupId: Maybe<Scalars['String']['output']>;
  photoId: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};

export type KeywordsList = {
  __typename?: 'KeywordsList';
  keywordsListId: Maybe<Scalars['ID']['output']>;
  list: Maybe<Array<Maybe<PhotoKeywords>>>;
};

export type LookBookDetailsForClient = {
  __typename?: 'LookBookDetailsForClient';
  configs: Maybe<Array<Maybe<LookBookProductConfig>>>;
  decorationPreConfig: Maybe<DecorationPreConfigForClient>;
  labs: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lookBookId: Maybe<Scalars['ID']['output']>;
  occasion: Maybe<LookBookOccasionForClient>;
  postOrderMessage: Maybe<Array<Maybe<CustomLabel>>>;
  spreadsCount: Maybe<Scalars['Int']['output']>;
  welcomeMessage: Maybe<Array<Maybe<CustomLabel>>>;
};

export type LookBookInBasketInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  countPhotos?: InputMaybe<LookBookProductImageLimitationInput>;
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  firstAddedFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPersonalization?: InputMaybe<Scalars['Boolean']['input']>;
  imageMap?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  lookBookProductConfigId?: InputMaybe<Scalars['ID']['input']>;
  lookBookProductId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  nameClientProduct?: InputMaybe<Scalars['String']['input']>;
  personalizationConfig?: InputMaybe<Scalars['String']['input']>;
  photoIdList?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  productsInPlay?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  redBackground?: InputMaybe<Scalars['Boolean']['input']>;
  thumb?: InputMaybe<Scalars['String']['input']>;
  valueMap?: InputMaybe<Scalars['String']['input']>;
};

export enum LookBookOccasionForClient {
  ChildSession = 'ChildSession',
  CoupleAnniversary = 'CoupleAnniversary',
  FamilyEvent = 'FamilyEvent',
  FirstCommunion = 'FirstCommunion',
  OtherOccasion = 'OtherOccasion',
  Wedding = 'Wedding',
}

export enum LookBookPriceRounding {
  Five = 'Five',
  One = 'One',
  Ten = 'Ten',
}

export type LookBookProductConfig = {
  __typename?: 'LookBookProductConfig';
  config: Maybe<Scalars['String']['output']>;
  cost: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  count: Maybe<Scalars['Int']['output']>;
  created: Maybe<Scalars['Int']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  hasPersonalization: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<Scalars['String']['output']>;
  lookBookProductConfigId: Maybe<Scalars['ID']['output']>;
  personalizationConfig: Maybe<Scalars['String']['output']>;
  sent: Maybe<Scalars['Boolean']['output']>;
  sentWhen: Maybe<Scalars['Int']['output']>;
  thumb: Maybe<Scalars['String']['output']>;
};

export type LookBookProductConfigUpdate = {
  config?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  thumb?: InputMaybe<Scalars['String']['input']>;
};

export type LookBookProductImageLimitation = {
  __typename?: 'LookBookProductImageLimitation';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type LookBookProductImageLimitationInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type LookBookProductInBasket = {
  __typename?: 'LookBookProductInBasket';
  accessToken: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  countPhotos: Maybe<LookBookProductImageLimitation>;
  finished: Maybe<Scalars['Boolean']['output']>;
  firstAddedFile: Maybe<Scalars['Boolean']['output']>;
  hasPersonalization: Maybe<Scalars['Boolean']['output']>;
  imageMap: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  lookBookProductConfigId: Maybe<Scalars['ID']['output']>;
  lookBookProductId: Maybe<Scalars['ID']['output']>;
  name: Maybe<Array<Maybe<CustomLabel>>>;
  nameClientProduct: Maybe<Scalars['String']['output']>;
  personalizationConfig: Maybe<Scalars['String']['output']>;
  photoIdList: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productsInPlay: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  quantity: Maybe<Scalars['Int']['output']>;
  redBackground: Maybe<Scalars['Boolean']['output']>;
  thumb: Maybe<Scalars['String']['output']>;
  timeAddedToShoppingCart: Maybe<Scalars['Int']['output']>;
  valueMap: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  insertLookBookProductConfigForClient: Maybe<LookBookProductConfig>;
  sendToPhotographer: Maybe<MutationStatus>;
  updateLookBookProductConfigForClient: Maybe<MutationStatus>;
  updateMock: Maybe<Scalars['Int']['output']>;
};

export type MutationInsertLookBookProductConfigForClientArgs = {
  label: Scalars['String']['input'];
  lookBookId: Scalars['ID']['input'];
  lookBookProductConfigId: Scalars['ID']['input'];
};

export type MutationSendToPhotographerArgs = {
  expectedCost: Scalars['Int']['input'];
  lookBookId: Scalars['ID']['input'];
};

export type MutationUpdateLookBookProductConfigForClientArgs = {
  hasPersonalization?: InputMaybe<Scalars['Boolean']['input']>;
  lookBookId: Scalars['ID']['input'];
  lookBookProductConfigId: Scalars['ID']['input'];
  personalizationConfig?: InputMaybe<Scalars['String']['input']>;
  productsInPlay?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  update: LookBookProductConfigUpdate;
  valueMap?: InputMaybe<Scalars['String']['input']>;
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type MutationStatus = {
  __typename?: 'MutationStatus';
  status: Maybe<Scalars['Boolean']['output']>;
};

export type NumberRange = {
  __typename?: 'NumberRange';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type PhotoKeywords = {
  __typename?: 'PhotoKeywords';
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  photoId: Maybe<Scalars['String']['output']>;
};

export type PriceConfig = {
  __typename?: 'PriceConfig';
  code: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['Float']['output']>;
};

export type PriceConfigInput = {
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
};

export type PriceStep = {
  __typename?: 'PriceStep';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  step: Maybe<Scalars['Int']['output']>;
};

export type PriceStepInput = {
  price: Array<InputMaybe<PriceConfigInput>>;
  step: Scalars['Int']['input'];
};

export type PrintAndFileConfig = {
  __typename?: 'PrintAndFileConfig';
  filesConfig: Maybe<Array<Maybe<FilesConfig>>>;
  forcedImage: Maybe<ForcedImageConfig>;
  groups: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mode: Maybe<FilesAndPrintsPackageType>;
  printAndFileConfigId: Maybe<Scalars['ID']['output']>;
  printsCount: Maybe<Array<Maybe<PrintsCount>>>;
};

export type PrintFormat = {
  __typename?: 'PrintFormat';
  label: Maybe<Scalars['String']['output']>;
  printFormatId: Maybe<Scalars['ID']['output']>;
};

export type PrintFrameInBasket = {
  __typename?: 'PrintFrameInBasket';
  count: Maybe<Scalars['Int']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printFormatId: Maybe<Scalars['ID']['output']>;
  printFrameId: Maybe<Scalars['ID']['output']>;
  ratio: Maybe<Scalars['Float']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type PrintFrameInBasketInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  photoId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  printFormatId?: InputMaybe<Scalars['ID']['input']>;
  printFrameId?: InputMaybe<Scalars['ID']['input']>;
  ratio?: InputMaybe<Scalars['Float']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PrintPaper = {
  __typename?: 'PrintPaper';
  label: Maybe<Scalars['String']['output']>;
  printPaperId: Maybe<Scalars['ID']['output']>;
};

export type PrintPriceConfig = {
  __typename?: 'PrintPriceConfig';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printFormatId: Maybe<Scalars['ID']['output']>;
  printPaperId: Maybe<Scalars['ID']['output']>;
  stepPricing: Maybe<StepPricing>;
  stepPricingEnabled: Maybe<Scalars['Boolean']['output']>;
};

export type PrintsConfig = {
  __typename?: 'PrintsConfig';
  formats: Maybe<Array<Maybe<PrintFormat>>>;
  papers: Maybe<Array<Maybe<PrintPaper>>>;
};

export type PrintsCount = {
  __typename?: 'PrintsCount';
  count: Maybe<Scalars['Int']['output']>;
  printFormatId: Maybe<Scalars['String']['output']>;
  printPaperId: Maybe<Scalars['String']['output']>;
};

export enum PrintsPricingContext {
  PrivateSession = 'PrivateSession',
  PublicSession = 'PublicSession',
  PublicSessionGroup = 'PublicSessionGroup',
  WeddingCouple = 'WeddingCouple',
  WeddingGallery = 'WeddingGallery',
}

export type PrintsPricingList = {
  __typename?: 'PrintsPricingList';
  context: Maybe<PrintsPricingContext>;
  label: Maybe<Scalars['String']['output']>;
  prices: Maybe<Array<Maybe<PrintPriceConfig>>>;
  printsPricingListId: Maybe<Scalars['ID']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
};

export type Product = {
  __typename?: 'Product';
  availableOnOccasion: Maybe<Array<Maybe<SessionOccasion>>>;
  composedImages: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['String']['output']>;
  configurationImages: Maybe<Scalars['String']['output']>;
  deliveryTime: Maybe<Scalars['Int']['output']>;
  description: Maybe<Array<Maybe<CustomLabel>>>;
  hasTaxConfig: Maybe<Scalars['Boolean']['output']>;
  hasWizard: Maybe<Scalars['Boolean']['output']>;
  imagesRequired: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['ID']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  productId: Maybe<Scalars['ID']['output']>;
  requiredImages: Maybe<NumberRange>;
  showDeliveryTime: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['Boolean']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taxConfig: Maybe<ProductTaxConfig>;
  type: Maybe<ProductType>;
};

export type ProductConfig = {
  __typename?: 'ProductConfig';
  config: Maybe<Scalars['String']['output']>;
  customName: Maybe<Array<Maybe<CustomLabel>>>;
  icon: Maybe<Scalars['String']['output']>;
  mode: Maybe<ProductMode>;
  productId: Maybe<Scalars['String']['output']>;
  productInPackageId: Maybe<Scalars['String']['output']>;
  qty: Maybe<Scalars['Int']['output']>;
};

export enum ProductMode {
  AllImagesFromPackage = 'AllImagesFromPackage',
  AnyImages = 'AnyImages',
  AnyImagesFromPackage = 'AnyImagesFromPackage',
}

export type ProductPackage = {
  __typename?: 'ProductPackage';
  allowMultiple: Maybe<Scalars['Boolean']['output']>;
  icon: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  printAndFileConfig: Maybe<Array<Maybe<PrintAndFileConfig>>>;
  productConfig: Maybe<Array<Maybe<ProductConfig>>>;
  productPackageId: Maybe<Scalars['ID']['output']>;
};

export type ProductTaxConfig = {
  __typename?: 'ProductTaxConfig';
  label: Maybe<Scalars['String']['output']>;
  vatRate: Maybe<Scalars['Int']['output']>;
};

export type ProductTaxConfigInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  vatRate?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductToProductRelation = {
  __typename?: 'ProductToProductRelation';
  id: Maybe<Scalars['String']['output']>;
  labId: Maybe<Scalars['String']['output']>;
  parentId: Maybe<Scalars['String']['output']>;
  productId: Maybe<Scalars['String']['output']>;
  type: Maybe<ProductToProductRelationType>;
  value: Maybe<Scalars['String']['output']>;
};

export enum ProductToProductRelationType {
  Attribute = 'Attribute',
  Lab = 'Lab',
  Option = 'Option',
  Product = 'Product',
}

export enum ProductType {
  Album = 'Album',
  AlbumSet2plusOne = 'AlbumSet2plusOne',
  AlbumSetTriple = 'AlbumSetTriple',
  AlbumWithAcrylicPicture = 'AlbumWithAcrylicPicture',
  Book = 'Book',
  Calendar = 'Calendar',
  Canvas = 'Canvas',
  EconomicTwoPageTablo = 'EconomicTwoPageTablo',
  FatPrint = 'FatPrint',
  Frame = 'Frame',
  IdentityPhoto = 'IdentityPhoto',
  MagnetSticker = 'MagnetSticker',
  Mug = 'Mug',
  Other = 'Other',
  Prints = 'Prints',
  Tablo = 'Tablo',
  Tambour = 'Tambour',
  Triplex = 'Triplex',
  Wallart = 'Wallart',
  ZalamoCalendar = 'ZalamoCalendar',
  ZalamoEconomicTwoPageTablo = 'ZalamoEconomicTwoPageTablo',
  ZalamoMagnet = 'ZalamoMagnet',
  ZalamoPremiumTwoPageTablo = 'ZalamoPremiumTwoPageTablo',
}

export type Query = {
  __typename?: 'Query';
  getDecorationForClient: Maybe<DecorationForClient>;
  getProductsForLab: Maybe<Array<Maybe<Product>>>;
  lookBookDetailsForClient: Maybe<LookBookDetailsForClient>;
  mock: Maybe<Scalars['String']['output']>;
  zalamoStandaloneAlbum: Maybe<Product>;
};

export type QueryGetDecorationForClientArgs = {
  decorationId: Scalars['ID']['input'];
};

export type QueryGetProductsForLabArgs = {
  lookBookId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryLookBookDetailsForClientArgs = {
  lookBookId: Scalars['ID']['input'];
};

export type QuickLink = {
  __typename?: 'QuickLink';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  link: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  quickLinkId: Maybe<Scalars['ID']['output']>;
};

export type RetouchLevel = {
  __typename?: 'RetouchLevel';
  label: Maybe<Array<Maybe<CustomLabel>>>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  retouchLevelId: Maybe<Scalars['ID']['output']>;
};

export type SessionAlbumLookBookConfigForDisplay = {
  __typename?: 'SessionAlbumLookBookConfigForDisplay';
  commission: Maybe<Scalars['Int']['output']>;
  excludedMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  excludedSizes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  labIds: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionLookBookConfigForDisplay = {
  __typename?: 'SessionLookBookConfigForDisplay';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  decorationPreConfig: Maybe<DecorationPreConfigForClient>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  printFramesConfig: Maybe<SessionPrintFramesLookBookConfigForDisplay>;
  sellAlbums: Maybe<Scalars['Boolean']['output']>;
  sellPrintFrames: Maybe<Scalars['Boolean']['output']>;
  sellTambour: Maybe<Scalars['Boolean']['output']>;
  sellTriplex: Maybe<Scalars['Boolean']['output']>;
  sellWallDecor: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  tambourConfig: Maybe<SessionWallDecorLookBookConfigForDisplay>;
  triplexConfig: Maybe<SessionTriplexLookBookConfigForDisplay>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  wallDecorConfig: Maybe<SessionWallDecorLookBookConfigForDisplay>;
};

export enum SessionOccasion {
  Baphthism = 'Baphthism',
  Birthday = 'Birthday',
  FirstBirthday = 'FirstBirthday',
  FirstCommunion = 'FirstCommunion',
  Newborn = 'Newborn',
  Wedding = 'Wedding',
}

export type SessionPrintFrameConfig = {
  __typename?: 'SessionPrintFrameConfig';
  color: Maybe<Scalars['String']['output']>;
  format: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  sessionPrintFrameConfigId: Maybe<Scalars['ID']['output']>;
  shape: Maybe<Scalars['String']['output']>;
};

export type SessionPrintFramesLookBookConfigForDisplay = {
  __typename?: 'SessionPrintFramesLookBookConfigForDisplay';
  availableColors: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  limitColors: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionTriplexLookBookConfigForDisplay = {
  __typename?: 'SessionTriplexLookBookConfigForDisplay';
  availableMaterials: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  labId: Maybe<Scalars['String']['output']>;
  limitMaterials: Maybe<Scalars['Boolean']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SessionWallDecorLookBookConfigForDisplay = {
  __typename?: 'SessionWallDecorLookBookConfigForDisplay';
  disablePersonalizationOnSinglePhoto: Maybe<Scalars['Boolean']['output']>;
  labId: Maybe<Scalars['String']['output']>;
  preConfig: Maybe<Scalars['String']['output']>;
  rounding: Maybe<LookBookPriceRounding>;
};

export type SoldFilesUniversalWatermarkConfig = {
  __typename?: 'SoldFilesUniversalWatermarkConfig';
  horizontal: Maybe<SoldFilesWatermarkConfig>;
  soldFilesUniversalWatermarkConfigId: Maybe<Scalars['ID']['output']>;
  vertical: Maybe<SoldFilesWatermarkConfig>;
};

export type SoldFilesWatermarkConfig = {
  __typename?: 'SoldFilesWatermarkConfig';
  alpha: Maybe<Scalars['Float']['output']>;
  config: Maybe<SoldFilesWatermarkConfigPosition>;
  file: Maybe<Scalars['String']['output']>;
  soldFilesWatermarkConfigId: Maybe<Scalars['ID']['output']>;
};

export type SoldFilesWatermarkConfigPosition = {
  __typename?: 'SoldFilesWatermarkConfigPosition';
  left: Maybe<Scalars['Float']['output']>;
  soldFilesWatermarkConfigPositionId: Maybe<Scalars['ID']['output']>;
  top: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type StepPricing = {
  __typename?: 'StepPricing';
  firstStep: Maybe<Scalars['Int']['output']>;
  isFirstStepFree: Maybe<Scalars['Boolean']['output']>;
  lastStepPrice: Maybe<Array<Maybe<PriceConfig>>>;
  mode: Maybe<StepPricingMode>;
  steps: Maybe<Array<Maybe<PriceStep>>>;
};

export type StepPricingInput = {
  firstStep: Scalars['Int']['input'];
  isFirstStepFree: Scalars['Boolean']['input'];
  lastStepPrice: Array<InputMaybe<PriceConfigInput>>;
  mode: StepPricingMode;
  steps: Array<InputMaybe<PriceStepInput>>;
};

export enum StepPricingMode {
  Bundles = 'Bundles',
  ForAll = 'ForAll',
  ForOverTreshold = 'ForOverTreshold',
  None = 'None',
}

export type Subscription = {
  __typename?: 'Subscription';
  mockSub: Maybe<Scalars['ID']['output']>;
};

export type TriplexRenderPreviewConfig = {
  __typename?: 'TriplexRenderPreviewConfig';
  accessToken: Maybe<Scalars['ID']['output']>;
  fileName: Maybe<Scalars['ID']['output']>;
  images: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  triplexRenderPreviewConfigId: Maybe<Scalars['ID']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type TriplexRenderPreviewConfigInput = {
  fileName?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFilesConfig = {
  count: Scalars['Int']['input'];
  isFull: Scalars['Boolean']['input'];
  size: Scalars['Int']['input'];
};

export type UpdatePrintsCount = {
  count: Scalars['Int']['input'];
  printFormatId: Scalars['String']['input'];
  printPaperId: Scalars['String']['input'];
};

export type UpdateProductConfig = {
  config: Scalars['String']['input'];
  customName?: InputMaybe<Array<InputMaybe<CustomLabelInput>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<ProductMode>;
  productId: Scalars['String']['input'];
  productInPackageId: Scalars['String']['input'];
  qty: Scalars['Int']['input'];
};

export enum VatType {
  Applied = 'Applied',
  Exempt = 'Exempt',
}

export type WallDecorPieceCrop = {
  __typename?: 'WallDecorPieceCrop';
  h: Maybe<Scalars['Float']['output']>;
  w: Maybe<Scalars['Float']['output']>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type WallDecorPieceCropInput = {
  h: Scalars['Float']['input'];
  w: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type WallDecorRenderPieceConfig = {
  __typename?: 'WallDecorRenderPieceConfig';
  crop: Maybe<WallDecorPieceCrop>;
  isFlip: Maybe<Scalars['Boolean']['output']>;
  photoGroupId: Maybe<Scalars['ID']['output']>;
  photoId: Maybe<Scalars['ID']['output']>;
  wallDecorPieceId: Maybe<Scalars['ID']['output']>;
};

export type WallDecorRenderPieceConfigInput = {
  crop: WallDecorPieceCropInput;
  isFlip: Scalars['Boolean']['input'];
  photoGroupId: Scalars['ID']['input'];
  photoId: Scalars['ID']['input'];
  wallDecorPieceId: Scalars['ID']['input'];
};

export type WallDecorRenderPreviewConfig = {
  __typename?: 'WallDecorRenderPreviewConfig';
  accessToken: Maybe<Scalars['ID']['output']>;
  color: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['ID']['output']>;
  images: Maybe<Array<Maybe<WallDecorRenderPieceConfig>>>;
  wallDecorRenderPreviewConfigId: Maybe<Scalars['ID']['output']>;
  wallDecorSceneId: Maybe<Scalars['ID']['output']>;
};

export type WallDecorRenderPreviewConfigInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['ID']['input']>;
  images?: InputMaybe<Array<InputMaybe<WallDecorRenderPieceConfigInput>>>;
  wallDecorSceneId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ZalamoObject {
  BookingPortfolio = 'BookingPortfolio',
  CompetitionEntry = 'CompetitionEntry',
  Conversation = 'Conversation',
  DesignerAsset = 'DesignerAsset',
  DigitalOrder = 'DigitalOrder',
  LegacyPrivateSessionFileOrder = 'LegacyPrivateSessionFileOrder',
  LookBookOrder = 'LookBookOrder',
  OldZalamoClient = 'OldZalamoClient',
  Order = 'Order',
  Organization = 'Organization',
  OrganizationClient = 'OrganizationClient',
  OrganizationPromoPrintFlyers = 'OrganizationPromoPrintFlyers',
  PrintsOrder = 'PrintsOrder',
  PrivateSession = 'PrivateSession',
  PrivateSessionGroup = 'PrivateSessionGroup',
  Product = 'Product',
  ProductInOrder = 'ProductInOrder',
  PublicSession = 'PublicSession',
  PublicSessionChildren = 'PublicSessionChildren',
  PublicSessionGroup = 'PublicSessionGroup',
  PublicSessionOrganization = 'PublicSessionOrganization',
  PublicSessionOrganizationGroup = 'PublicSessionOrganizationGroup',
  SupportThread = 'SupportThread',
  ZalamoPrintOrder = 'ZalamoPrintOrder',
}

export type ZalamoPrintSessionConfig = {
  __typename?: 'ZalamoPrintSessionConfig';
  addEveryFileToBasketIfNotAlreadyBought: Maybe<Scalars['Boolean']['output']>;
  addPriceToEveryFileInProduct: Maybe<Scalars['Boolean']['output']>;
  calendarPrice: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  enabledTabloSizes: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  magnetPrice: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  priceToAddToEveryFileInProduct: Maybe<Array<Maybe<PriceConfig>>>;
  sellCalendar: Maybe<Scalars['Boolean']['output']>;
  sellMagnet: Maybe<Scalars['Boolean']['output']>;
  sellTablo: Maybe<Scalars['Boolean']['output']>;
  skipAddToEveryFileInProductIfFileBought: Maybe<Scalars['Boolean']['output']>;
  tabloPricing: Maybe<Array<Maybe<ZalamoPrintSessionTabloPricingConfig>>>;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct: Maybe<
    Scalars['Boolean']['output']
  >;
  zalamoPrintSessionConfigId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionConfigInput = {
  addEveryFileToBasketIfNotAlreadyBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  addPriceToEveryFileInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  calendarPrice?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  enabledTabloSizes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  magnetPrice?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  priceToAddToEveryFileInProduct?: InputMaybe<
    Array<InputMaybe<PriceConfigInput>>
  >;
  sellCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  sellMagnet?: InputMaybe<Scalars['Boolean']['input']>;
  sellTablo?: InputMaybe<Scalars['Boolean']['input']>;
  skipAddToEveryFileInProductIfFileBought?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  tabloPricing?: InputMaybe<
    Array<InputMaybe<ZalamoPrintSessionTabloPricingConfigInput>>
  >;
  useFilePricingToCalculatePriceToAddToEveryFileInProduct?: InputMaybe<
    Scalars['Boolean']['input']
  >;
};

export type ZalamoPrintSessionTabloConfig = {
  __typename?: 'ZalamoPrintSessionTabloConfig';
  formatLabel: Maybe<Scalars['String']['output']>;
  price: Maybe<Array<Maybe<PriceConfig>>>;
  tabloIndex: Maybe<Scalars['Int']['output']>;
  zalamoPrintSizeId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionTabloPricingConfig = {
  __typename?: 'ZalamoPrintSessionTabloPricingConfig';
  price: Maybe<Array<Maybe<PriceConfig>>>;
  zalamoPrintSizeId: Maybe<Scalars['ID']['output']>;
};

export type ZalamoPrintSessionTabloPricingConfigInput = {
  price?: InputMaybe<Array<InputMaybe<PriceConfigInput>>>;
  zalamoPrintSizeId?: InputMaybe<Scalars['ID']['input']>;
};
